export default __webpack_public_path__ + "static/media/AURA_PLUS.d2649404.jpg";